import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import "react-perfect-scrollbar/dist/css/styles.css"
import "react-quill/dist/quill.snow.css"
import "nprogress/nprogress.css"
import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { I18nextProvider } from "react-i18next"
import i18next from "i18next"
import * as serviceWorker from "./serviceWorker"
import { store, persistor } from "./redux/stores/store"
import App from "./App"
import { resources } from "./translations/index"
import { initYupLocale } from "./utils/yup/initYupLocale"

i18next.init({
  interpolation: { escapeValue: false },
  lng: "es",
  resources,
})

initYupLocale()

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
)

serviceWorker.register()
